import { useTranslation } from 'react-i18next';
import { IconButton } from '@citiguide/ui-components';
import { usePlansStore } from '../../store/plansStore';
import MyPlansModal from './MyPlansModal';

const PlansIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M6 3h12a1 1 0 0 1 1 1v17l-7-4-7 4V4a1 1 0 0 1 1-1z" />
  </svg>
);

/** Sits next to the MainMenu toggle; opens the saved-plans list. */
export default function MyPlansButton() {
  const { t } = useTranslation();
  const openModal = usePlansStore((s) => s.openModal);
  return (
    <>
      <IconButton
        icon={<PlansIcon />}
        label={t('plans.button')}
        variant="floating"
        size="md"
        round
        className="main-menu__plans"
        onClick={openModal}
      />
      <MyPlansModal />
    </>
  );
}
